<template>

  <el-main class="main_content" style="padding: 0">
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>统计管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item><a @click="jumpTo('/filialeOrder')">分公司订单统计</a></el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">

      <div class="contain_header clr">
        <el-form class="m-search" size='small' :model="filters">
          <el-row>


          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="下单时间">
                <el-row>
                  <el-col :span="10">

                    <el-date-picker type="date" placeholder="选择开始日期" v-model="filters.startTime"
                      style="width: 100%;"></el-date-picker>
                  </el-col>

                  <el-col :span="1">
                    <div style="display: inline-block;width:100%;text-align:center">-</div>
                  </el-col>
                  <el-col :span="10">
                    <el-date-picker type="date" placeholder="选择结束日期" v-model="filters.endTime"
                      style="width: 100%;"></el-date-picker>
                  </el-col>
                </el-row>

              </el-form-item>
            </el-col>

            <el-col :offset="1" :span="8">

              <el-form-item label="订单状态">
                <el-select v-model="filters.status" clearable>
                  <el-option v-for="option in typeOptions" :value="option.id" :key='option.id'
                    :label="option.title"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8">
              <el-form-item label="代理信息:">
                <el-input style="width: 200px;" v-model="filters.telephone" placeholder="请输入代理手机号">
                </el-input>

              </el-form-item>
            </el-col>

            <el-col :offset="1" :span="8">
              <el-form-item label="分公司名称">
                <el-select v-model="filters.companyid" clearable>
                  <!-- <el-option v-for="option in companyNameList"
                  :value="option.id"
                  :key='option.id'
                  :lable ="option.company_name">
                </el-option> -->

                <el-option v-for="option in companyNameList" :value="option.id" :key='option.id'
                    :label="option.company_name"></el-option>

                </el-select>
              </el-form-item>
            </el-col>

            <el-button style="margin-left:10px" @click="handleSearch" type="primary" size="small">搜索</el-button>
            <el-button style="margin-left:10px" @click="excelOut" type="danger" size="small">导出订单</el-button>

          </el-row>


        </el-form>
        <div style="width:10px;height:10px"></div>
      </div>
      <span class='totalM'>总金额：{{ total_money }}元</span>
      <div class="contain_body">
        <div class="contain_body_head">
        </div>
        <el-table :data="tableData" :height="tableHeight" v-loading='tableDataLoading' style="width: 100%"
          :header-cell-class-name='objectSpanMethod'>

          <el-table-column prop="username" label="代理姓名">
            <template slot-scope="scope">
              <span>{{ scope.row.username }}</span>(<span>{{ scope.row.telephone }}</span>)
            </template>
          </el-table-column>
          <el-table-column prop="company_name" label="分公司名称">
          </el-table-column>

          <el-table-column prop="order_code" label="订单号">
            <template slot-scope="scope">
            <router-link
                target="_blank"
                :to="{path:'/orderDetailNew',query:{orderId:scope.row.id,sendName:scope.row.send_name}}"
              >{{scope.row.order_code}}
            </router-link>
          </template>
          </el-table-column>

          <el-table-column prop="send_name" label="发货人">
          </el-table-column>

          <el-table-column prop="total_money" label="总金额">
          </el-table-column>

          <el-table-column prop="create_time_op" label="下单时间">
          </el-table-column>

          <el-table-column prop="province" label="地址信息 " :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{ scope.row.receiving_username }} {{ scope.row.receiving_telephone }} {{ scope.row.receiving_province }}{{ scope.row.receiving_city }}{{scope.row.receiving_district}}{{ scope.row.receiving_address_detail }}
            </template>
          </el-table-column>


          <el-table-column prop="status_name" label="状态">
          </el-table-column>


        </el-table>
        <div class="pageDiv block">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="page_num" :page-count='total_page' :page-size="page_size"
            layout="total, prev, pager, next" :total="total_num">
          </el-pagination>
        </div>
      </div>

    </div>

  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc";
var _ = require("lodash");
export default {
  name: "orderList",
  data() {
    return {
      editForm: {
        id: null,
        orderCode: null
      },
      editForm1: {
        id: null,
        orderRemork: null
      },
      subListVisible: false,
      totalMoney: {
        total_money: 0,
        score_price: 0
      },
      total_money:0,
      typeOptions: [
      {
          id: 1,
          title: "待支付"
        },
        {
          id: 2,
          title: "待发货"
        },
        {
          id: 3,
          title: "待收货"
        },
        // {
        //   id: 7,
        //   title: "待自提"
        // },
        // {
        //   id: 8,
        //   title: "已自提"
        // },
        {
          id: 4,
          title: "已完成"
        },
        {
          id: 5,
          title: "已取消"
        }
      ],
      orderTypeOne: [
        {
          id: 2,
          title: "待发货"
        },
        {
          id: 3,
          title: "待收货"
        },
        {
          id: 7,
          title: "待自提"
        },
        {
          id: 8,
          title: "已自提"
        },
        {
          id: 4,
          title: "已发货"
        }
      ],
      companyNameList: [],
      addExcelSnedLoading: false,
      errMsg: null,
      dialogBatchInVisible: false,
      batchInPostLoading: false,
      tableDataLoading: false,
      searchUserId: null,
      tableData1: [],
      addFormRule: {
        excelFile: [
          { required: true, message: "请选择Excel文件", trigger: "blur" }
        ]
      },
      addLoading: false,
      editFormRule: {
        orderCode: [
          { required: true, message: "请输入单号", trigger: "blur" }
        ]
      },
      editFormRule1: {
        orderRemork: [
          { required: true, message: "请输入备注", trigger: "blur" }
        ]
      },
      dialogVisible: false,
      form: {
        excelFile: null
      },
      file: null,
      filters: {
        sendUser: null,
        expire_type: null,
        orderType: "1",
        address: null,
        title: null,
        status: null,
        telephone:null,
        companyid: null,
        send_type: null,
        startTime: null,
        roleType: null,
        endTime: null,
        status: null,
        userInfo: null,
        goodName: null,
        printStatus: null,
      },
      isCollapse: true,
      activeName: "second",
      page_num: 1,
      keywords: "",
      value4: "",
      subList: [],
      buList: [],
      pickerOptions1: 1,
      value2: "",
      options: ["阿德的", "豆得儿"],
      tableData: [],
      total_num: 0,
      subListLoading: false,
      total_page: 0,
      page_size: 10,
      tableHeight: null,
      orderDD: {},
      provinceOptions: [],
      provinceList: null,
    };
  },
  mounted() {
    this.companyList();
    this.handleSearch();
  },
  methods: {
    companyList() {
      var that = this;
      let para = {
        token: localStorage.getItem("api_token")
      }
      API.h5_company_list(para)
        .then(
          (result) => {
            if (result && parseInt(result.key) === 1000) {
              let list = [];
              for (let i = 0; i < result.result.list.length; i++) {
                list.push({ id: result.result.list[i].id, company_name: result.result.list[i].company_name })
              }
              // console.log(list);
              this.companyNameList = list;
              // console.log(this.companyNameList)
            }
          },
          function (err) {
            that.addLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
    },

    excelOut() {
      var that = this;
      var url =
        "/manager/user/pc/h5_order_count_excel?token=" +
        localStorage.getItem("api_token");
      if (that.filters.telephone) {
        url = url + "&telephone=" + that.filters.telephone;
      }
      if (that.filters.startTime) {
        url = url + "&startTime=" + that.filters.startTime.getTime();
      }
      if (that.filters.endTime) {
        url = url + "&endTime=" + that.filters.endTime.getTime();
      }
      if (that.filters.status) {
        url = url + "&status=" + that.filters.status;
      }
      if(that.filters.companyid){
        url =url+"&companyId=" + that.filters.companyid;
      }
      top.location.href = url;
    },

    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    search() {
      let that = this;
      let params = {
        pageNum: that.page_num,
        pageSize: that.page_size,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.telephone) {
        params.telephone = that.filters.telephone;
      }
      if (that.filters.startTime) {
        params.startTime = that.filters.startTime.getTime();
      }
      if (that.filters.endTime) {
        params.endTime = that.filters.endTime.getTime();
      }
      if (that.filters.status) {
        params.status = that.filters.status;
      }
      if(that.filters.companyid) {
        params.companyId = that.filters.companyid;
      }
      that.tableDataLoading = true;
      API.h5_order_count(params)
        .then(
          function (result) {
            that.tableDataLoading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                  if (result.result.list[i].send_time != null) {
                    result.result.list[i].send_time1 = dateFunc.formatDate(
                      new Date(parseInt(result.result.list[i].send_time)),
                      "yyyy-MM-dd hh:mm:ss"
                    );
                  }
                }
              }
              that.total_money = result.result.map.totalM
              that.tableData = result.result.list;
            }
          },
          function (err) {
            that.tableDataLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.tableDataLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
      // API.order_money(params)
      //   .then(
      //     function (result) {
      //       if (result.key == 1000) {
      //         that.totalMoney = result.result.map;
      //       }
      //     },
      //     function (err) {
      //       that.tableDataLoading = false;
      //       that.$message.error({
      //         showClose: true,
      //         message: err.toString(),
      //         duration: 2000
      //       });
      //     }
      //   )
      //   .catch(function (error) {
      //     that.tableDataLoading = false;
      //     console.log(error);
      //     that.$message.error({
      //       showClose: true,
      //       message: "请求出现异常",
      //       duration: 2000
      //     });
      //   });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    },
    hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}

.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}

.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}

.contain_div {
  margin: 10px;
}

.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}

.contain_header {
  background-color: #fff;
  padding: 10px;
}

.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}

.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}

.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}

.totalM {
  display: inline-block;
  margin-top: 10px;
  font-size: 20px;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/good/filialeOrder.vue